import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-[#5B401F]" data-id="element-135" data-mp="ejwl1drxcj8d">
      {/* Radial gold glow background */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(224,183,86,0.15)_0%,_transparent_70%)]" data-id="element-136" data-mp="9lbfcytwl7cj"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-20 text-center" data-id="element-137" data-mp="4jvw9cbadaws">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-relaxed md:leading-snug mb-10" data-id="element-138" data-mp="128pft6wt8l1e">
          ¿Y si la abundancia que estás buscando empieza con una relación más profunda con Dios?
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-lg md:text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed" style={{
        color: "#F7F2E7"
      }} data-id="element-139" data-mp="3d1sa6w93nhsl">
          Descubre el método de 30 días que te ayudará a renovar tu mente, fortalecer tu fe, recuperar tu paz y experimentar provisión y abundancia cada día.  
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mb-12" data-id="element-140" data-mp="39a36gxl5v9lq">
          <div className="relative inline-block" data-id="element-141" data-mp="30h9ebzkm8fqg">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(224,183,86,0.3)_0%,_transparent_70%)] blur-3xl" data-id="element-142" data-mp="358hlsq2dxr0z"></div>
            <img src="https://cdn.magicpatterns.com/uploads/nmMAuyqWHpW1fxvv42u3jV/EL_JARDIN_SUBCONSCIENTE_(3).png" alt="Método R.E.V.E.L.A. - 30 Días con Dios para Vivir en Abundancia desde la Fe" className="relative block w-full max-w-md mx-auto rounded-lg shadow-2xl" data-id="element-143" data-mp="2ql692kugw0za" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="flex flex-col items-center gap-4" data-id="element-144" data-mp="2lk8vklkejv44">
          <motion.a href="#oferta-final" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-gradient-to-r from-[#C9A24B] to-[#E0B756] text-[#0A1535] font-bold text-lg px-10 py-5 rounded-full shadow-lg hover:shadow-2xl transition-shadow" style={{
          color: "#F7F2E7",
          paddingLeft: "40px",
          paddingRight: "40px"
        }} data-id="element-145" data-mp="n9qf903poc37">
            QUIERO COMENZAR MI MÉTODO R.E.V.E.L.A — $17 USD
          </motion.a>
          <p className="text-[#E0B756] text-sm" data-id="element-146" data-mp="15zq17e499b2e">
            Acceso inmediato · Pago único en tu moneda local - Descarga digital 100% imprimible
          </p>
        </motion.div>
      </div>
    </section>;
}